import { render, staticRenderFns } from "./WriteArticle.vue?vue&type=template&id=e0636850&scoped=true&"
import script from "./WriteArticle.vue?vue&type=script&lang=js&"
export * from "./WriteArticle.vue?vue&type=script&lang=js&"
import style0 from "./WriteArticle.vue?vue&type=style&index=0&id=e0636850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0636850",
  null
  
)

export default component.exports